module.exports = __webpack_public_path__ + "static/media/bus7.c5ae2269.jpg";